 <!-- Show/Edit Sprintname -->
<div id='sprintname'>
  <h3 *ngIf="!editModeSprintName">{{selectedSprint?.name}}</h3>
  <input *ngIf="editModeSprintName" (keyup.enter)="toggleSprintNameEdit($event)" [(ngModel)]="selectedSprint.name">
  <i *ngIf="!editModeSprintName" class="material-icons" (click)="toggleSprintNameEdit($event)">edit</i>
  <i *ngIf="editModeSprintName" class="material-icons" (click)="changeSprintName($event)">check_circle</i>
</div>

<!-- Select Sprint -->
<label>Sprint</label>
<div class="dropdown">
  <select class="dropdown__select" [(ngModel)]="selectedSprintId" (change)="onSelectedSprintChanged()">
    <option class="dropdown__item" *ngFor="let sprint of sprints" [value]="sprint.id">
      {{sprint.name}}
    </option>
  </select>
  <div class="dropdown__icon">
    <i class="material-icons">keyboard_arrow_down</i>
  </div>
</div>

<!-- Button Create Sprint -->
<div>
  <button mat-raised-button class="accept-button" (click)="createSprint()" [disabled]="selectedSprintId == null">
    {{'widgets.sprintplanning.createsprint' | translate}}
  </button>
</div>

